import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import auth0 from '../../../helpers/auth0';

var MenuItem = createReactClass({
  propTypes: {
    to: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    claim: PropTypes.string.isRequired,
    icon: PropTypes.string
  },

  getInitialState() {
    return {
      isOpen: false
    };
  },

  isUrlActive(url) {
    let { location } = this.props;

    if(url === '/')
    {
      return location.pathname === '/';
    }

    let match = location.pathname.includes(url);

    if(match) {
      return true;
    }

    return false;
  },

  render() {
    let { claim, to, displayName, icon, children, matchhint } = this.props;
    let { isOpen } = this.state;

    if(!auth0.hasClaim(claim)){
      return null;
    }

    let isActive = this.isUrlActive(matchhint || to);

    if (!children || children.length === 0) {
      // Link item
      if(icon) {
        return (
          <li className={isActive ? 'open' : ''}>
            <Link to={to} others={{title: displayName}}>
              <i className={`fa fa-lg fa-${icon}`}></i> <span className="menu-item-parent" style={{marginLeft: 5}}>{displayName}</span>
            </Link>
          </li>
        );
      } else {
        return (
          <li className={isActive ? 'open' : ''} >
            <Link to={to} others={{title: displayName}} onClick={e => e.stopPropagation()}>
              {displayName}
            </Link>
          </li>
        );
      }

    } else {
      // Group item
      return (
        <li className={isActive ? 'open' : ''}>
          <a href="#" onClick={e => { this.setState({ isOpen: !isOpen })}}>
            <i className={`fa fa-lg fa-${icon}`}></i> <span className="menu-item-parent" style={{marginLeft: 5}}>{displayName}</span>
            <b className="collapse-sign"><em className="fa fa-plus-square-o"></em></b>
          </a>
          <ul style={{display: (isActive || isOpen) ? 'block' : 'none'}}>
            {children}
          </ul>
        </li>
      );
    }
  }

});

export default withRouter(MenuItem);



// WEBPACK FOOTER //
// ./src/components/common/MainMenu/MenuItem.js